/**
 * Custom markdown syntax for mentions:
 * @{{"text": "Cool people", "type": "segment", "id": "123"}}
 * @{{"text": "Login page", "type": "page", "id": "234"}}
 * @{{"text": "Submit button", "type": "feature", "id": "456"}}
 *
 * The inner set of brackets defines a JSON object that can include any metadata required to render the inline mention.
 */
import { renderMention } from '@/common/marked/extension-mentions/render-mention';

const mentionsRegex = /@{{.*?}}/;
const mentionsTokenizer = /^@{({.*?})}/;
const mentionsReplacer = /@{({.*?})}/g;

/**
 * A marked extension for rendering the custom markdown syntax for mentions to html
 */
export const extensionMentions = {
    name: 'mention',
    level: 'inline',
    start: (src) => {
        const match = src.search(mentionsRegex);

        return match === -1 ? undefined : match;
    },
    tokenizer: (src) => {
        const match = mentionsTokenizer.exec(src);
        if (!match) return;

        return {
            type: 'mention',
            raw: match[0],
            metadata: parseMentionMetadata(match[1]),
        };
    },
    renderer: (token) => {
        const { metadata } = token;
        const { text, type, id } = metadata;

        return text ? renderMention(type, id, text) : '';
    },
};

/**
 * Replace the custom markdown syntax for mentions with plaintext
 */
export function replaceMentions (text) {
    const replacer = (match, metadata) => {
        const data = parseMentionMetadata(metadata);

        return data.text || '';
    };

    return text.replace(mentionsReplacer, replacer);
}

function parseMentionMetadata (text) {
    try {
        return JSON.parse(text);
    } catch {
        return {};
    }
}
